// @flow

import { AppConfig } from '../../config';
import HttpRequest from '../../utils/httprequest';

import { type CmsType } from './types/common';

const FetchXMLContent = async (cmsFor: CmsType) => {
    const xmlContent = await HttpRequest(
        `${AppConfig.XmlContentPath}${cmsFor.File}`,
        {},
        'text'
    );
    return xmlContent.response;
};
export default FetchXMLContent;
